var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPythonLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 35",
    style: {
      enableBackground: "new 0 0 34 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M33.4,13c-0.8-3.2-2.5-4.8-5-4.8h-2.5V5.6c0-2.5-2-4.7-4.8-5.2c-1.3-0.2-2.7-0.3-4.2-0.3c-1.3,0-2.7,0.1-3.8,0.3 C9.5,1,8.2,2.5,8.2,5.6v2.6H6.6c-2.9,0-5.2,1.9-5.9,4.8c-0.8,3.1-0.8,5.1,0,8.3c0.7,3,2.6,4.8,5.2,4.8h2.3v2.6c0,2.3,1.7,4.2,4.7,5 c1.4,0.4,2.8,0.6,4.1,0.6c1.4,0,2.7-0.2,4.1-0.6c4.1-1.2,4.7-3.7,4.7-5v-2.6h2.5c3.4,0,4.4-2.9,5-4.7C34.2,18.8,34.2,16.3,33.4,13z  M7.2,23.6H5.9c-1.4,0-2.4-1-2.8-2.9c-0.7-2.8-0.7-4.4,0-7.1c0.4-1.8,1.7-2.9,3.5-2.9H17c0.7,0,1.2-0.6,1.2-1.2v-1 c0-0.7-0.6-1.2-1.2-1.2h-6.3V5.6c0-1.5,0.1-2.2,2.8-2.7c1-0.2,2.2-0.3,3.4-0.3c1.3,0,2.6,0.1,3.7,0.3c1.4,0.2,2.7,1.2,2.7,2.7v7.2 c0,1.4-1.1,2.6-2.5,2.6h-7.6c-3.2,0-6,2.7-6,6V23.6z M31,20.6c-0.9,2.6-1.5,3-2.6,3H17c-0.7,0-1.2,0.6-1.2,1.2v1 c0,0.7,0.6,1.2,1.2,1.2h6.3v1.6c0,1.2-1,2.1-2.9,2.6C18,32,16,32,13.6,31.3c-1.1-0.3-2.9-1.1-2.9-2.6v-7.2c0-1.4,1.2-2.6,2.5-2.6 h7.6c3.2,0,6-2.8,6-6.1v-2.1h1.6c0.9,0,1.9,0.3,2.6,2.9C31.6,16.5,31.7,18.5,31,20.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9,27.7c0.8,0,1.4,0.7,1.4,1.5c0,0.8-0.6,1.5-1.4,1.5c-0.8,0-1.4-0.7-1.4-1.5C18.4,28.4,19.1,27.7,19.9,27.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7,3.6c0.8,0,1.5,0.7,1.5,1.5c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5C12.2,4.3,12.9,3.6,13.7,3.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythonLogo);
export default __webpack_public_path__ + "static/media/python-logo.4a493659a4f596dc1f93ee276c2c42f4.svg";
export { ForwardRef as ReactComponent };